import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { BookSwitchData } from '@lyceo/lyceo-pupil-app/practise/util-models';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/lyceo-pupil-app/shared/util-environment';
import { ScopeDto } from './+state/scope/scope.model';
import { MethodsForScopeDto } from './+state/method/method.model';

@Injectable({
  providedIn: 'root',
})
export class ScopeService {
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);
  private readonly http: HttpClient = inject(HttpClient);

  public getPersonScopes(personId: string): Observable<ScopeDto[]> {
    const url: string = `${this.environment.practiceApiUrl}/api/person/${personId}/scopes`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<ScopeDto[]>(url, {
      headers: headersToSend,
    });
  }

  public getMethodsForScope(scopes: string[]): Observable<MethodsForScopeDto> {
    const url: string = `${this.environment.biebApiUrl}/api/v3/scopes/methods`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.post<MethodsForScopeDto>(
      url,
      { scopes },
      {
        headers: headersToSend,
      },
    );
  }

  public switchBook(
    personId: string,
    body: BookSwitchData,
  ): Observable<ScopeDto> {
    const url: string = `${this.environment.practiceApiUrl}/api/person/${personId}/switch-book`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.post<ScopeDto>(url, body, {
      headers: headersToSend,
    });
  }

  public switchBooks(
    personId: string,
    bookSwitches: BookSwitchData[],
  ): Observable<ScopeDto[]> {
    if (!bookSwitches.length) {
      return of([]);
    }
    return forkJoin(
      bookSwitches.map((bookSwitch) => this.switchBook(personId, bookSwitch)),
    );
  }
}
